module.exports = __webpack_public_path__ + "images/social-media-kit-28852e26384895cefa2582e4d5749ead.svg";